var _path, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGettingStarted(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 9,
    height: 16,
    viewBox: "0 0 9 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_200_18977",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 1,
    width: 9,
    height: 14
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.877341 1.81957C0.756944 1.83147 0.703665 1.96811 0.778825 2.07012L3.96935 6.40586C4.04498 6.50823 3.99129 6.64493 3.87131 6.65677L2.6032 6.78235C2.47991 6.79468 2.42755 6.93752 2.50986 7.03932L7.70651 14.6027C7.74853 14.6552 7.806 14.675 7.85807 14.6698C7.93969 14.6615 8.00894 14.5926 7.99055 14.4915L6.93617 8.77795C6.9195 8.68839 6.97787 8.60883 7.06617 8.59998L7.89938 8.51765C7.9881 8.50874 8.04647 8.42918 8.02986 8.34003L6.75008 1.40356C6.73347 1.31442 6.6485 1.24889 6.55979 1.2578L0.877817 1.81992L0.877341 1.81957Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_200_18977)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.17792 1.43204L4.79688 0.337891L11.2513 9.8626L9.63233 10.9568L3.17792 1.43204Z",
    fill: "url(#paint0_linear_200_18977)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-1.35997 2.48414L1.19727 0.755859L8.94884 12.1948L6.3916 13.9231L-1.35997 2.48414Z",
    fill: "url(#paint1_linear_200_18977)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_200_18977",
    x1: 3.75282,
    y1: 1.16424,
    x2: 13.374,
    y2: 13.7575,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFFBEE",
    stopOpacity: 0.64
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCC40B",
    stopOpacity: 0.5
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_200_18977",
    x1: -0.47312,
    y1: 2.02977,
    x2: 10.8782,
    y2: 17.3237,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFFBEE",
    stopOpacity: 0.64
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCC40B",
    stopOpacity: 0.5
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGettingStarted);
export default __webpack_public_path__ + "static/media/getting-started.aa80596e060f1bdf1d42631aa220772f.svg";
export { ForwardRef as ReactComponent };